import React from "react";
import type { ChakraProps } from "@chakra-ui/react";
import { SwiperNavButton } from "components/ProductGallery/SwiperStyles";
import { ChevronLeftIcon, ChevronRightIcon } from "../SvgIcons";
import { colours, shadows } from "@shared/ui.design-system";

type Props = {
  prevButtonRef: React.RefObject<HTMLDivElement>;
  nextButtonRef: React.RefObject<HTMLDivElement>;
  nextSlide: () => void;
  prevSlide: () => void;
  nextBtnStyles?: ChakraProps;
  prevBtnStyles?: ChakraProps;
  nextIconStyles?: ChakraProps;
  prevIconStyles?: ChakraProps;
  arrowsColor?: string;
  arrowsShadow?: boolean;
  iconSize?: string;
  additionalClassName?: string;
};

export const CarouselNav: React.FC<Props> = ({
  prevButtonRef,
  nextButtonRef,
  nextSlide,
  prevSlide,
  nextBtnStyles,
  prevBtnStyles,
  nextIconStyles,
  prevIconStyles,
  arrowsColor,
  arrowsShadow,
  iconSize = "2rem",
  additionalClassName
}) => {
  return (
    <>
      <SwiperNavButton
        className={`swiper-button-prev ${additionalClassName}`}
        ref={prevButtonRef}
        bgColor="transparent !important"
        border="none !important"
        ml={1}
        onClick={() => prevSlide()}
        {...prevBtnStyles}
        css={{
          "&.swiper-button-disabled": {
            opacity: "0 !important"
          },
          "&::after": {
            display: "none"
          }
        }}
      >
        <ChevronLeftIcon
          boxSize={iconSize}
          {...prevIconStyles}
          color={arrowsColor}
          filter={
            arrowsShadow ? `drop-shadow(${shadows.bottom.l1})` : undefined
          }
        />
      </SwiperNavButton>
      <SwiperNavButton
        className="swiper-button-next"
        ref={nextButtonRef}
        bgColor="transparent !important"
        border="none !important"
        mr={1}
        onClick={() => nextSlide()}
        {...nextBtnStyles}
        css={{
          "&.swiper-button-disabled": {
            opacity: "0 !important"
          },
          "&::after": {
            display: "none"
          }
        }}
      >
        <ChevronRightIcon
          boxSize={iconSize}
          {...nextIconStyles}
          color={arrowsColor}
          outline="black"
          filter={
            arrowsShadow
              ? `drop-shadow(3px 3px 2px ${colours.transparency.dark})`
              : undefined
          }
        />
      </SwiperNavButton>
    </>
  );
};
